import { Stack, Typography } from "@mui/material";
import { Button } from "components/UI";
import { useBankStore } from "features/finances";
import { BankTable } from "../Tables";

export const BankAccounts = () => {
  const openCreateBankAccountModal = useBankStore(
    state => state.openCreateBankAccountModal
  );

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          Add bank accounts
        </Typography>
        <Typography variant="caption" textAlign="center">
          Provide your church&apos;s bank account information to enable seamless
          financial management.
        </Typography>
        <Button onClick={openCreateBankAccountModal}>Add bank account</Button>

        <Stack alignSelf="stretch">
          <BankTable onboarding />
        </Stack>
      </Stack>
    </>
  );
};
